import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { resetAllStores } from '../sharedActions';
import { verificaTourBoasVindas, insereRegistroBoasVindas } from './thunks';

const TOTAL_ETAPAS_TOUR = 6;

const tourBoasVindasSlice = createSlice({
  name: 'tourBoasVindas',
  initialState,
  reducers: {
    resetTourBoasVindas: () => initialState,
    marcarTourFechado: (state) => {
      state.exibir = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(resetAllStores, () => initialState);

    builder.addCase(verificaTourBoasVindas.pending, (state) => {
      state.isLoading = true;
      state.error = '';
    });

    builder.addCase(verificaTourBoasVindas.fulfilled, (state, action) => {
      state.isLoading = false;
      const payload = action.payload ?? {};
      // API retorna campos capitalizados (Exibir, EtapaAtual); normalizamos
      // para camelCase no estado local.
      const etapa = payload.EtapaAtual ?? 0;
      state.etapaAtual = etapa;
      state.exibir = (payload.Exibir ?? false) && etapa < TOTAL_ETAPAS_TOUR;
    });

    builder.addCase(verificaTourBoasVindas.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || 'Erro ao verificar tour';
    });

    builder.addCase(insereRegistroBoasVindas.pending, (state) => {
      state.isLoading = true;
      state.error = '';
    });

    builder.addCase(insereRegistroBoasVindas.fulfilled, (state, action) => {
      state.isLoading = false;
      const etapa = action.meta.arg ?? state.etapaAtual;
      state.etapaAtual = etapa;
    });

    builder.addCase(insereRegistroBoasVindas.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || 'Erro ao inserir registro';
    });
  },
});

export const tourBoasVindas = tourBoasVindasSlice.reducer;
export const { resetTourBoasVindas, marcarTourFechado } =
  tourBoasVindasSlice.actions;
